import { DEFAULT_ALBUM_ART } from '@/utils/artwork';

export interface Channel {
  id: string;
  name: string;
  description: string;
  status: string;
  liveSongs: number;
  liveRotations: number;
  songs: number;
  rotations: number;
  lastUpdated: string;
  artwork: string;
  featuredArtists: string;
  genres: string;
}

export const channels: Channel[] = [
  {
    id: '1',
    name: 'KK Original Coffee Shop',
    description: 'Perfect coffee shop vibes with smooth jazz and acoustic tunes',
    status: 'LIVE',
    liveSongs: 150,
    liveRotations: 25,
    songs: 150,
    rotations: 25,
    lastUpdated: '07/01/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Norah Jones, Jack Johnson, John Mayer',
    genres: 'Jazz, Acoustic, Folk',
  },
  {
    id: '2',
    name: 'KK Original Dance',
    description: 'High-energy dance music for clubs and parties',
    status: 'LIVE',
    liveSongs: 200,
    liveRotations: 30,
    songs: 200,
    rotations: 30,
    lastUpdated: '07/20/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Calvin Harris, David Guetta, The Chainsmokers',
    genres: 'EDM, Dance, Pop',
  },
  {
    id: '3',
    name: 'KK Original Pop',
    description: 'Chart-topping pop hits and contemporary favorites',
    status: 'APPROVED',
    liveSongs: 180,
    liveRotations: 28,
    songs: 180,
    rotations: 28,
    lastUpdated: '06/29/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Taylor Swift, Ed Sheeran, Ariana Grande',
    genres: 'Pop, Contemporary',
  },
  {
    id: '4',
    name: 'KK Original Tropical House',
    description: 'Island vibes and tropical house beats',
    status: 'NOT LIVE',
    liveSongs: 120,
    liveRotations: 20,
    songs: 120,
    rotations: 20,
    lastUpdated: '07/23/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Kygo, Thomas Jack, Lost Frequencies',
    genres: 'Tropical House, Electronic',
  },
  {
    id: '5',
    name: 'KK Original Sunrise Spa',
    description: 'Relaxing spa and wellness music',
    status: 'APPROVED',
    liveSongs: 90,
    liveRotations: 15,
    songs: 90,
    rotations: 15,
    lastUpdated: '07/12/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Moby, Zero 7, Enya',
    genres: 'Ambient, Chillout, Spa',
  },
  {
    id: '6',
    name: "50's Swing",
    description: 'Classic swing and big band music from the 1950s',
    status: 'LIVE',
    liveSongs: 160,
    liveRotations: 22,
    songs: 160,
    rotations: 22,
    lastUpdated: '06/30/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Frank Sinatra, Dean Martin, Ella Fitzgerald',
    genres: 'Swing, Big Band, Jazz',
  },
  {
    id: '7',
    name: "60's Groove",
    description: 'Iconic 1960s rock, pop, and soul classics',
    status: 'LIVE',
    liveSongs: 175,
    liveRotations: 26,
    songs: 175,
    rotations: 26,
    lastUpdated: '05/10/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'The Beatles, The Rolling Stones, Aretha Franklin',
    genres: 'Rock, Pop, Soul',
  },
  {
    id: '8',
    name: "70's Flashback",
    description: 'Disco, funk, and rock from the 1970s',
    status: 'NOT LIVE',
    liveSongs: 140,
    liveRotations: 24,
    songs: 140,
    rotations: 24,
    lastUpdated: '04/03/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Bee Gees, ABBA, Fleetwood Mac',
    genres: 'Disco, Funk, Rock',
  },
  {
    id: '9',
    name: "80's Awesome Hits",
    description: 'Iconic hits from the 1980s',
    status: 'APPROVED',
    liveSongs: 130,
    liveRotations: 18,
    songs: 130,
    rotations: 18,
    lastUpdated: '03/29/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Michael Jackson, Madonna, Prince',
    genres: 'Pop, Rock, New Wave',
  },
  {
    id: '10',
    name: "90's Revolution",
    description: 'Alternative and grunge from the 1990s',
    status: 'LIVE',
    liveSongs: 145,
    liveRotations: 21,
    songs: 145,
    rotations: 21,
    lastUpdated: '07/03/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Nirvana, Pearl Jam, Radiohead',
    genres: 'Alternative, Grunge, Rock',
  },
  {
    id: '11',
    name: '2K Rewind',
    description: 'Hit Music From 2000 to 2010!',
    status: 'LIVE',
    liveSongs: 165,
    liveRotations: 23,
    songs: 165,
    rotations: 23,
    lastUpdated: '06/14/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Britney Spears, Eminem, Coldplay',
    genres: 'Pop, Hip Hop, Rock',
  },
  {
    id: '12',
    name: 'Pop Hits',
    description: 'Current chart-topping pop hits',
    status: 'APPROVED',
    liveSongs: 155,
    liveRotations: 20,
    songs: 155,
    rotations: 20,
    lastUpdated: '07/16/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Taylor Swift, Ed Sheeran, Ariana Grande',
    genres: 'Pop, Contemporary',
  },
  {
    id: '13',
    name: 'Pop Remix',
    description: 'Remixed versions of popular songs',
    status: 'APPROVED',
    liveSongs: 110,
    liveRotations: 16,
    songs: 110,
    rotations: 16,
    lastUpdated: '07/19/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Various Artists',
    genres: 'Pop, Remix, Dance',
  },
  {
    id: '14',
    name: 'Country Hits',
    description: 'Top country music hits',
    status: 'LIVE',
    liveSongs: 125,
    liveRotations: 19,
    songs: 125,
    rotations: 19,
    lastUpdated: '07/22/24',
    artwork: DEFAULT_ALBUM_ART,
    featuredArtists: 'Luke Combs, Morgan Wallen, Carrie Underwood',
    genres: 'Country, Americana',
  }
]; 